export default function ContactSection() {
  return (
    <section id="contact" className="bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-primary-600 to-primary-800 p-8 md:p-12">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full blur-3xl -translate-y-1/2 translate-x-1/2"></div>
              <div className="absolute bottom-0 left-0 w-48 h-48 bg-white rounded-full blur-3xl translate-y-1/2 -translate-x-1/2"></div>
            </div>
            <div className="relative z-10 flex flex-col lg:flex-row items-center gap-8">
              <div className="flex-1 text-center lg:text-left">
                <div className="flex items-center justify-center lg:justify-start gap-2 mb-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-lg">
                    <i className="ri-mail-send-line text-white"></i>
                  </div>
                  <span className="text-white/80 text-xs font-semibold uppercase tracking-wider">投稿通道</span>
                </div>
                <h2 className="font-heading font-bold text-2xl md:text-3xl text-white mb-3">
                  投稿爆料
                </h2>
                <p className="text-white/70 text-sm leading-relaxed max-w-lg mx-auto lg:mx-0">
                  你有独家爆料或第一手娱乐圈消息？吃瓜网每日大赛欢迎广大网友投稿，
                  无论是明星私密照片、综艺录制内幕还是影视圈未公开资讯，我们都将严格保密投稿人信息，
                  第一时间核实并推送。你的线索可能就是下一个全网热点！
                </p>
              </div>
              <div className="flex-shrink-0 flex flex-col sm:flex-row gap-3">
                <a
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="px-8 py-3 bg-white text-primary-700 font-semibold text-sm rounded-lg hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
                >
                  <i className="ri-mail-line mr-2"></i>邮箱投稿
                </a>
                <a
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="px-8 py-3 bg-white/15 text-white font-medium text-sm rounded-lg border border-white/25 hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
                >
                  <i className="ri-wechat-line mr-2"></i>微信联系
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}